import { useEffect } from 'react';
export function useEloquaTracking({ eloquaSiteId }) {
    useEffect(() => {
        window._elqQ = [];
        window._elqQ.push(['elqSetSiteId', eloquaSiteId]);
        window._elqQ.push(['elqTrackPageView', window.location.href]);
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//img03.en25.com/i/elqCfg.min.js';
        const x = document.getElementsByTagName('script')[0];
        x?.parentNode?.insertBefore(s, x);
        window._elqQ.push(['elqGetCustomerGUID']);
    }, []);
}
